import styled from 'styled-components';

export const VirtualOfficeSubscriptionStyled = styled.div`
  cursor: pointer;
  background: ${(props) => props.theme.colors.neutral100};
  border-radius: 15px;
  padding: 20px;
  width: 100%;
  min-height: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  @media (max-width: 800px) {
    padding: 16px;
  }
`;

export const MostPopular = styled.div`
  padding: 5px 20px;
  background: linear-gradient(90deg, #dbbb7b 0%, #a17c56 100%);
  display: inline-flex;
`;
